import React, { memo, Suspense, useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { context } from '../../../globalState/GlobalState';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import './css/Schedule1.css';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { isValidObject, isValidString } from '../../../catalog/Validity';
import ScheduleNavBar1 from './ScheduleNavBar1';
import ScheduleGames1 from './ScheduleGames1';
import SeasonsComponent2 from '../../uiElements/seasonsComponents/seasonsComponent2/SeasonsComponent2';
import Title4 from '../../uiElements/title/title4/Title4';

const Schedule1 = (props) => {
    const { season, previousGames, scheduledGames, loadingSpinner } = props;
    const { globalState } = useContext(context);
    const params = useParams();

    const getBreadCrumbsLinks = () => {
        if (isValidObject(season) && isValidObject(season.name)) {
            return [
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Schedule',
                    link: '/schedule',
                },
            ];
        }
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={isValidObject(season) && isValidObject(season.name) ? `Season ${season.name}` : 'Schedule'} marginLeft="100px" />
                    <div className="schedule1-container-container x-center p-t-20px p-b-20px p-l-50px p-r-50px m-b-20px">
                        <Title4 title={isValidObject(season) && isValidObject(season.name) ? `Season ${season.name}` : 'Schedule'} />
                        <div className="schedule1-container m-t-0">
                            <ScheduleNavBar1>
                                <Suspense fallback={<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />}>
                                    <Switch>
                                        {isValidString(params.seasonid) ? (
                                            <>
                                                <Route path="/seasonschedule/:seasonid/upcoming" exact render={() => { return <ScheduleGames1 games={scheduledGames} loadingSpinner={loadingSpinner} scheduled unavailableText="No Upcoming Games" />; }} />
                                                <Route path="/seasonschedule/:seasonid/results" exact render={() => { return <ScheduleGames1 games={previousGames} loadingSpinner={loadingSpinner} scheduled={false} unavailableText="Results Unavailable" />; }} />
                                                <Route render={() => { return <Redirect to={{ pathname: `/seasonschedule/${params.seasonid}/upcoming` }} />; }} />
                                            </>
                                        ) : (
                                            <>
                                                <Route path="/schedule/upcoming" exact render={() => { return <ScheduleGames1 games={scheduledGames} loadingSpinner={loadingSpinner} scheduled unavailableText="No Upcoming Games" />; }} />
                                                <Route path="/schedule/results" exact render={() => { return <ScheduleGames1 games={previousGames} loadingSpinner={loadingSpinner} scheduled={false} unavailableText="Results Unavailable" />; }} />
                                                {/* <Route render={() => { return <Redirect to={{ pathname: '/schedule/upcoming' }} />; }} /> */}
                                            </>
                                        )}
                                    </Switch>
                                </Suspense>
                            </ScheduleNavBar1>
                        </div>
                        <div className="schedule1-seasons m-t-40px">
                            <SeasonsComponent2 />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

Schedule1.propTypes = {
    season: PropTypes.object,
    previousGames: PropTypes.array.isRequired,
    scheduledGames: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

Schedule1.defaultProps = {
    season: null,
};

export default memo(Schedule1);
